import { apiClient } from './config';

/**
 * Get company data for current user
 */
export const getCompanyData = async () => {
  const response = await apiClient.get('/data');
  return response.data;
};

/**
 * Get all clients data (admin only)
 */
export const getAllClientsData = async () => {
  const response = await apiClient.get('/companies/all');
  return response.data;
};

/**
 * Upload JSON file for company data
 */
export const uploadJsonFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/data/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
